import Vue        from "vue";
import App        from "./App.vue";
import VueRouter  from "vue-router";

//pages
import Home       from "./pages/Home.vue";
import Dashboard  from "./pages/Dashboard.vue";
import RecipeEdit from "./pages/RecipeEdit.vue";
import Recipes    from "./pages/RecipeIndex.vue";
import RecipeShow from "./pages/RecipeShow.vue";
import Streams    from "./pages/Streams.vue";

import upperFirst from "lodash/upperFirst";
import camelCase  from "lodash/camelCase";
import  "./helpers/filters";
import BrewSessionEdit from "./pages/BrewSessionEdit";
import VueAnalytics from 'vue-analytics';

Vue.use(VueRouter);

Vue.config.productionTip = false;

const requireComponent = require.context(
  "./components", // The relative path of the components folder
  true, // Whether or not to look in subfolders
  /Base[A-Z]\w+\.(vue|js)$/ // The regular expression used to match base component filenames
);



requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  );
});

Vue.mixin({
  methods: {
    batchVolumeUnit()       { return "l"; },
    fermentableWeightUnit() { return "kg"; },
    hopWeightUnit()         { return "g"; },
    otherWeightUnit()       { return "g"; },
    hopBoilTimeUnit()       { return "min"; },
    otherBoilTimeUnit()     { return "min"; },
    dryHopTimeUnit()        { return "d"; },
    temperatureUnit()       { return "C"; },

    getQueryParams(paramsObj = {}) {
      let query = [];

      let defaultParams = {
        sort: { name: 'ASC' },
        pagination: { number: 1, size: 25 }
      };

      let params = _.extend({}, defaultParams, paramsObj);

      if (params.pagination) {
        for (const paginationItem in params.pagination) {
          if (params.pagination.hasOwnProperty(paginationItem)) {
            query.push(`page[${paginationItem}]=${params.pagination[paginationItem]}`);
          }
        }
      }

      if (params.sort) {
        for (const sortItem in params.sort) {
          if (params.sort.hasOwnProperty(sortItem)) {
            query.push(`sort[${sortItem}]=${params.sort[sortItem]}`);
          }
        }
      }

      if (params.filter) {
        for (const filterItem in params.filter) {
          if (params.filter.hasOwnProperty(filterItem)) {
            query.push(`filter[${filterItem}]=${params.filter[filterItem]}`);
          }
        }
      }

      return `?${query.join('&')}`;
    }
  }
});

const router = new VueRouter({
  mode: "history",
  base: __dirname,
  routes: [
    { path: "/", beforeEnter() { location.href = '/'} },
    { path: "/admin", beforeEnter() { location.href = '/admin'} },
    { path: "/app",                       component: Home,            name: "home" },
    { path: "/app/dashboard",             component: Dashboard,       name: "dashboard" },
    { path: "/app/recipes/:id/edit",      component: RecipeEdit,      name: "edit-recipe" },
    { path: "/app/recipes",               component: Recipes,         name: "recipes" },
    { path: "/app/recipes/:id",           component: RecipeShow,      name: "recipe-show" },
    { path: "/app/streams",               component: Streams,         name: "streams" },
    { path: "/app/brew-session/:id/edit", component: BrewSessionEdit, name: "brew-session-edit" },
    { path: "/app/*",                     component: Home,            name: "404" }
  ]
});
if (typeof webpackHotUpdate  !== 'function') {
  Vue.use(VueAnalytics, {
    id: 'UA-167106151-1',
    router
  });
}

window.vm = new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
